import StairsIconPath from "@ingka/ssr-icon/paths/stairs";

export default StairsIconPath;
